import { api } from './api';
import { PartnerTokenTierConfig, PartnerTokenTierConfigUpdateInput } from '../types/partnerToken';

export const DEFAULT_PARTNER_TOKEN_TIERS: PartnerTokenTierConfig[] = [
  {
    id: 1,
    tier: 'simple',
    name: 'Prepared',
    badge_letter: 'S',
    description: 'Create your own virtual tabletop scenario and complete on your own time.',
    price_cents: 50000,
    includes_audit: false,
    includes_facilitation: false,
    is_active: true,
    display_order: 1,
  },
  {
    id: 2,
    tier: 'gold',
    name: 'Prepared+',
    badge_letter: 'G',
    description: 'Create your own virtual tabletop scenario and submit your results for an after-action ISO 22301 compliance assessment. When the client uses the token, Flash is notified to begin the assessment.',
    price_cents: 100000,
    includes_audit: true,
    includes_facilitation: false,
    is_active: true,
    display_order: 2,
  },
  {
    id: 3,
    tier: 'premium',
    name: 'Executive',
    badge_letter: 'P',
    description: 'Create your own virtual tabletop scenario and schedule professional facilitation by a Flash AI facilitator. When the client uses the token, Flash AI is notified to coordinate facilitation. Facilitation is not an ISO certification.',
    price_cents: 225000,
    includes_audit: false,
    includes_facilitation: true,
    is_active: true,
    display_order: 3,
  },
];

class PartnerTokenService {
  async getPartnerTokenTiers(): Promise<PartnerTokenTierConfig[]> {
    try {
      const response = await api.get('/v1/partner-tokens/tiers');
      return Array.isArray(response.data) && response.data.length > 0 ? response.data : DEFAULT_PARTNER_TOKEN_TIERS;
    } catch (err) {
      console.warn('Falling back to default partner token tiers:', err);
      return DEFAULT_PARTNER_TOKEN_TIERS;
    }
  }

  async getAdminPartnerTokenTiers(): Promise<PartnerTokenTierConfig[]> {
    try {
      const response = await api.get('/v1/admin/partner-tokens/tiers');
      return Array.isArray(response.data) && response.data.length > 0 ? response.data : DEFAULT_PARTNER_TOKEN_TIERS;
    } catch (err) {
      console.warn('Falling back to default partner token tiers for admin:', err);
      return DEFAULT_PARTNER_TOKEN_TIERS;
    }
  }

  async updatePartnerTokenTier(
    tier: string,
    data: PartnerTokenTierConfigUpdateInput
  ): Promise<PartnerTokenTierConfig> {
    const response = await api.put(`/v1/admin/partner-tokens/tiers/${tier}`, data);
    return response.data;
  }
}

export const partnerTokenService = new PartnerTokenService();
